import { EarthBrainViewerAPIs } from "./EarthBrainViewerAPIs";
import { Color } from "cesium";
export class Drawing2DImageAPIs extends EarthBrainViewerAPIs {
    async addDrawing2dImage(args) {
        await this._scDesign.addDrawing2dImage(args);
    }
    removeDrawing2dImage(id) {
        this._scDesign.removeDrawing2dImage(Number(id));
    }
    updateDrawing2dImageVisibility(id, status) {
        this._scDesign.updateDrawing2dImageVisibility(Number(id), status);
    }
    updateDrawing2dImageTransparency(id, alpha) {
        this._scDesign.updateDrawing2dImageTransparency(Number(id), alpha);
    }
    zoomToDrawing2dImage(id) {
        this._scDesign.zoomToDrawing2dImage(id);
    }
    async startEditDrawing2dImage(id, callback) {
        await this._scDesign.startEditDrawing2dImage(id, callback);
    }
    async endEditDrawing2dImage() {
        await this._scDesign.endEditDrawing2dImage();
    }
    async start2PointsAlignment(id, callback) {
        await this._scDesign.start2PointsAlignment(id, callback);
    }
    async end2PointsAlignment(args) {
        await this._scDesign.end2PointsAlignment(args);
    }
    async cancel2PointsAlignment() {
        await this._scDesign.cancel2PointsAlignment();
    }
    async pickSourcePointFor2PointsAlignment(color) {
        return await this._scDesign.pickSourcePointFor2PointsAlignment(Color.fromCssColorString(color));
    }
    async startPickingDestinationPointFor2PointsAlignment(color, callback) {
        return await this._scDesign.startPickingDestinationPointFor2PointsAlignment(Color.fromCssColorString(color), callback);
    }
    async endPickingDestinationPointFor2PointsAlignment() {
        return await this._scDesign.endPickingDestinationPointFor2PointsAlignment();
    }
    async updateDestinationPositionFor2PointsAlignment(localPosition) {
        return await this._scDesign.updateDestinationPositionFor2PointsAlignment(localPosition);
    }
    async cancelEditDrawing2dImage() {
        await this._scDesign.cancelEditDrawing2dImage();
    }
    async addDrawing2dImageFromJSON(assetId, file, args) {
        await this._scDesign.addReferenceTopologyFromJSON(assetId, file, args);
    }
    getJSONOfDrawing2dImage(id) {
        return this._scDesign.getJSONOfReferenceTopology(id);
    }
    async setElevationOfDrawing2dImage(id, elevation) {
        await this._scDesign.setElevationOfDrawing2dImage(id, elevation);
    }
    getElevationOfDrawing2dImage(id) {
        return this._scDesign.getElevationOfDrawing2dImage(id);
    }
    getDrawing2DImageMeshGeometry(id) {
        return this._scDesign.getDrawing2DImageMeshGeometry(id);
    }
    startDrawing2DImageConstruction(callback) {
        this._scDesign.startDrawing2dImageConstruction(callback);
    }
    finishDrawing2DImageConstruction() {
        this._scDesign.finishDrawing2dImageConstruction();
    }
    cancelDrawing2DImageConstruction() {
        this._scDesign.cancelDrawing2dImageConstruction();
    }
    checkDrawing2DImageUnderConstruction() {
        return this._scDesign.checkDrawing2DImageUnderConstruction();
    }
}
//# sourceMappingURL=drawing-2d-image-APIs.js.map